<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <h6 class="bold text-primary m-0">
        Professional Info
        <CIcon
          v-if="!isModalView"
          name="cil-info"
          class="hinticon-multi-select mr-1"
          v-c-tooltip="' See Profile Section below for Additional Details'"
        />
        <em
          v-if="!isModalView"
          class="fas fa-angle-double-down"
          style="cursor: pointer"
          @click="$parent.goToExpendableSection()"
        ></em>
      </h6>
      <div class="d-flex justify-content-end action-wrapper">
        <a class="px-2 btn" v-if="isEditable" @click="editProfessionalInfo">
          <i class="fas fa-pencil-alt" alt="Edit" />
        </a>
      </div>
    </div>
    <CRow v-if="!isStudent">
      <CCol>
        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Speciality</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ speciality }}</span>
          </CCol>
        </CRow>
        <CRow v-if="!isDentist && !isNonClinicalAdmin" class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">{{
              isNurse ? `Expertise` : `Sub Speciality`
            }}</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ subSpeciality }}</span>
          </CCol>
        </CRow>
        <CRow v-if="!isNonClinicalAdmin" class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Special Interest</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ specialInterests }}</span>
          </CCol>
        </CRow>
        <CRow v-if="isDentist || isNonClinicalAdmin" class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">{{
              isNonClinicalAdmin
                ? "Highest Qualification"
                : "Highest Medical Qual"
            }}</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ qualificationName || "--" }}</span>
          </CCol>
        </CRow>

        <CRow
          class="profileView"
          v-if="showMore && !isDentist && !isNonClinicalAdmin"
        >
          <CCol lg="4">
            <label class="text-gray font-13">{{isStudent ? 'Course level':'Highest Medical Qual'}}</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ qualificationName || "--" }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="isNonClinicalAdmin">
          <CCol lg="4">
            <label class="text-gray font-13">Country Obtained</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ qualification_country }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="showMore && !isNonClinicalAdmin && !isStudent">
          <CCol lg="4">
            <label class="text-gray font-13">Country Obtained</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ qualification_country }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="showMore && !isNonClinicalAdmin && isStudent">
          <CCol lg="4">
            <label class="text-gray font-13">Study Location</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ study_location }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="showMore && isStudent">
          <CCol lg="4">
            <label class="text-gray font-13">Course Start Date</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ courseStartDate }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="showMore && isStudent">
          <CCol lg="4">
            <label class="text-gray font-13">Course End Date</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ courseEndDate }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="showMore && isStudent">
          <CCol lg="4">
            <label class="text-gray font-13">Course Mode</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ studentCourse?.full_part_time || '--' }}</span>
          </CCol>
        </CRow>        
        <CRow class="profileView" v-if="showMore && isStudent">
          <CCol lg="4">
            <label class="text-gray font-13">Sponsored student</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ profile.is_sponsored ?'Yes': 'No' }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="showMore && !isStudent">
          <CCol lg="4">
            <label class="text-gray font-13">Year Obtained</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ qualification_year }}</span>
          </CCol>
        </CRow>
        <CRow
          class="profileView"
          v-if="
            showMore && !isNonClinicalAdmin && !isCandidateRoleFromAccessToken
          "
        >
          <CCol lg="4">
            <label class="text-gray font-13">Suitable For</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ pqrlevel }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView" v-if="showMore && isNonClinicalAdmin">
          <CCol lg="4">
            <label class="text-gray font-13"> Working As</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ candidateLevel || "--" }}</span>
          </CCol>
        </CRow>
        <CRow class="profileView no-line" v-if="showMore">
          <CCol lg="4">
            <label class="text-gray font-13">Current Job Title</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ profile.current_job || "--" }}</span>
          </CCol>
        </CRow>
        <CRow>
          <CCol
            class="more-less bottom-line text-center"
            @click="ShowMoreLess()"
          >
            <i
              class="fa fa-chevron-circle-up"
              title="Show less"
              v-if="showMore"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-chevron-circle-down"
              title="Show more"
              v-else
              aria-hidden="true"
            ></i>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <CRow v-if="isStudent && !studentCourse">
      <CCol>
        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Study Location</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ studentQualification.country_name || "--" }}</span>
          </CCol>
        </CRow>

        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Course level</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ studentQualification.qualification_name || "--" }}</span>
          </CCol>
        </CRow>

        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Course Start Date</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ formatDate(studentQualification.course_start_date) || "--" }}</span>
          </CCol>
        </CRow>

        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Course End Date</label>
            <CIcon
                  name="cil-info"
                  class="hinticon-multi-select"
                  v-c-tooltip="'Including Internship'"
                />
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ formatDate(studentQualification.predicted_completion_date) || "--" }}</span>
          </CCol>
        </CRow>

        <div class="profileView no-line" v-if="showMore">
          <CRow class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Is your course</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">{{ studentQualification.full_part_time || "--" }}</span>
            </CCol>
          </CRow>

          <CRow class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Course Mode</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">
                {{ studentQualification && studentQualification.distance_learning === true ? 'Yes' : (studentQualification && studentQualification.distance_learning === false ? 'No' : 'Classroom based') }}
              </span>
            </CCol>
          </CRow>

          <CRow class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Sponsored student</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">{{ isSponsored ? `Yes` : "No" }}</span>
            </CCol>
          </CRow>
          <CRow v-if="isSponsored" class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Sponsorship Duration</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">{{ formatDate(sponsoredDetails.start_date) }} - {{ sponsoredDetails.end_date ? formatDate(sponsoredDetails.end_date) : '?'}}</span>
            </CCol>
          </CRow>
          <!-- <CRow v-if="isSponsored" class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Sponsorship Expiry Date</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">{{ formatDate(sponsoredDetails.end_date) }}</span>
            </CCol>
          </CRow> -->
        </div>
        <CRow>
          <CCol
            class="more-less bottom-line text-center"
            @click="ShowMoreLess()"
          >
            <i
              class="fa fa-chevron-circle-up"
              title="Show less"
              v-if="showMore"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-chevron-circle-down"
              title="Show more"
              v-else
              aria-hidden="true"
            ></i>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <CRow v-if="isStudent && studentCourse">
      <CCol>
        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Course Title</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ trainingCourse?.course_title || "--" }}</span>
          </CCol>
        </CRow>

        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Is your course</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ studentCourse.full_part_time || "--" }}</span>
          </CCol>
        </CRow>

        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Start Date</label>
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ formatDate(studentCourse.course_start_date) || "--" }}</span>
          </CCol>
        </CRow>

        <CRow class="profileView">
          <CCol lg="4">
            <label class="text-gray font-13">Completion Date</label>
            <CIcon
                  name="cil-info"
                  class="hinticon-multi-select"
                  v-c-tooltip="'Including Internship'"
                />
          </CCol>
          <CCol lg="8">
            <span class="text-black">{{ formatMonthYear(studentCourse.course_end_date) || "--" }}</span>
          </CCol>
        </CRow>

        <div class="profileView no-line" v-if="showMore">
          <CRow class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Course Mode</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">
                {{ studentCourse && studentCourse.distance_learning === true ? 'Yes' : (studentCourse && studentCourse.distance_learning === false ? 'No' : 'Classroom based') }}
              </span>
            </CCol>
          </CRow>

          <CRow class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Sponsored student</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">{{ isSponsored ? `Yes` : "No" }}</span>
            </CCol>
          </CRow>
          <CRow v-if="isSponsored" class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Sponsorship Start Date</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">{{ formatDate(sponsoredDetails.start_date) }}</span>
            </CCol>
          </CRow>
          <CRow v-if="isSponsored" class="profileView">
            <CCol lg="4">
              <label class="text-gray font-13">Sponsorship Expiry Date</label>
            </CCol>
            <CCol lg="8">
              <span class="text-black">{{ formatDate(sponsoredDetails.end_date) }}</span>
            </CCol>
          </CRow>
        </div>
        <CRow>
          <CCol
            class="more-less bottom-line text-center"
            @click="ShowMoreLess()"
          >
            <i
              class="fa fa-chevron-circle-up"
              title="Show less"
              v-if="showMore"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-chevron-circle-down"
              title="Show more"
              v-else
              aria-hidden="true"
            ></i>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <ProfessionalInfoEdit
      :candidateInfo="profile"
      :isShowPopup="EditModal.isShowPopup"
      @modalCallBack="ProfessionalInfoModalCallBack"
      v-if="EditModal.isShowPopup"
    />
    <Modal
      v-if="splConfirmModal.isShowPopup"
      :modalTitle="splConfirmModal.modalTitle"
      :modalColor="splConfirmModal.modalColor"
      :modalContent="splConfirmModal.modalContent"
      :isShowPopup="splConfirmModal.isShowPopup"
      :buttons="splConfirmModal.buttons"
      :modalCallBack="splModalCallBack"
      :closeOnBackdrop="false"
    />
  </div>
</template>
<script>
import { Role, getScope } from "@/helpers/helper";
import ProfessionalInfoEdit from "./EditForm/ProfessionalInfoEdit";
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/reusable/Modal";
import isJobSupplier from "@/mixins/isJobSupplier";
import m from "moment";

export default {
  mixins: [isJobSupplier],
  props: {
    profile: {
      type: Object,
      default: null,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ProfessionalInfoEdit,
    Modal,
  },
  data() {
    return {
      currentUserRole: getScope(),
      Role,
      EditModal: {
        isShowPopup: false,
      },
      splConfirmModal: {
        modalColor: "primary",
        modalTitle: "NOTIFICATION",
        modalContent: "Do you need to reset the Special Interest?",
        isShowPopup: false,
        buttons: ["No", "Yes"],
      },
      showMore: false,
    };
  },
  computed: {
    ...mapGetters([
      "getLicense",
      "currentUserType",
      "isCandidateRoleFromAccessToken",
      "isEducationalInstituteOrg"
    ]),
    isStudent(){
      return this.profile?.is_student || false
    },
    studentCourse(){
      return this.profile?.qualifications?.length ? this.profile?.qualifications[0]: '--';
    },
    study_location(){
      return this.studentCourse?.country_name || '--'
    },
    courseStartDate(){
      return this.studentCourse ? this.formatDate(this.studentCourse.course_start_date): '--'
    },
    courseEndDate(){
      return this.studentCourse ? this.formatDate(this.studentCourse.predicted_completion_date): '--'
    },

    getCandidateSpecialInterest() {
      return (
        (this.profile?.candidate_specialities &&
          this.profile?.candidate_specialities) ||
        []
      );
    },
    speciality() {
      return this.profile.speciality?.speciality || "--";
    },
    subSpeciality() {
      if (this.isDentist) return "N/A";
      return this.profile.sub_speciality?.sub_speciality || "--";
    },
    pqrlevel() {
      const pqr =
        this.profile.pqr_levels.filter(({ potential }) => !potential) || [];
      if (pqr.length) {
        if (pqr[0]?.working_candidate_level && !this.isAHP) {
          const level = pqr[0]?.working_candidate_level;
          const country_code =
            pqr[0]?.pqr_detail?.pqr_header?.country?.country_code;
          return country_code ? `${level}(${country_code})` : level;
        }
      }
      return "--";
    },
    candidateLevel() {
      return this.profile?.candidate_level?.candidate_level || "--";
    },
    qualification_year() {
      let index = this.profile.qualifications.findIndex(
        (x) => x.qualification_name === this.profile.highest_qualification_name
      );
      return this.profile.qualifications[index]?.year_awarded || "--";
    },
    qualification_country() {
      let index = this.profile.qualifications.findIndex(
        (x) => x.qualification_name === this.profile.highest_qualification_name
      );
      return this.profile.qualifications[index]?.country_name || "--";
    },
    psvDataFlow() {
      if (this.profile.psv_dataflow_complete != null) {
        if (["Yes", true, "all"].includes(this.profile.psv_dataflow_complete)) {
          return "All";
        } else if (
          ["No", false, "none"].includes(this.profile.psv_dataflow_complete)
        ) {
          return "None";
        } else if (this.profile.psv_dataflow_complete === "some") {
          return "Some";
        }
      }
      return "N/A";
    },
    specialInterests() {
      return (
        _(this.getCandidateSpecialInterest)
          .filter(({ special_interest, other_special_interest }) => {
            return other_special_interest || special_interest;
          })
          .map(({ special_interest, other_special_interest }) => {
            return !other_special_interest
              ? special_interest?.special_interest
              : "Other - " + other_special_interest;
          })
          .value()
          .join(", ") || "--"
      );
    },
    highestQualification() {
      return (
        (this.profile?.qualifications &&
          this.profile.qualifications.length > 1 &&
          this.profile?.qualifications.filter(({ main }) => main)) ||
        (this.profile.qualifications.length === 1 &&
          this.profile?.qualifications) ||
        []
      );
    },
    qualificationName() {
      if (
        this.profile?.qualifications &&
        this.profile?.highest_qualification_name &&
        this.profile?.highest_qualification_name == "Other - not listed"
      ) {
        return _(this.profile?.qualifications)
          .filter((qualification) => {
            return (
              qualification?.main &&
              qualification?.qualification_name ==
                this.profile?.highest_qualification_name
            );
          })
          .map((qualification) => {
            return qualification?.other_qualification_name
              ? "Other - " + qualification?.other_qualification_name
              : null;
          })
          .value()
          .toString();
      } else {
        return (
          this.highestQualification.length &&
          this.highestQualification
            .map(
              ({
                qualification_name,
                description,
                qualification: { allow_subject_input },
              }) =>
                `${qualification_name}${
                  allow_subject_input && description
                    ? "(" + description + ")"
                    : ""
                }`
            )
            .join()
        );
      }
    },
    activeLicense() {
      let activeLicense = this.getLicense
        ? this.getLicense.some((ele) => ele.current_license == true)
        : false;
      return activeLicense ? "Yes" : "No";
    },
    isNurse() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 2
        : false;
    },
    isAHP() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 3
        : false;
    },
    isDentist() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 4
        : false;
    },
    isNonClinicalAdmin() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 6
        : false;
    },
    isStudent(){
      return this.profile.is_student || false;
    },
    studentQualification() {
      return this.profile?.qualifications?.[0] || {};
    },
    isSponsored() {
      return this.profile?.is_sponsored
    },
    sponsoredDetails() {
      return this.profile?.sponsored
    },
    studentCourse() {
      return this.profile?.student_course
    },
    trainingCourse() {
      return this.profile?.student_course?.training_course
    },
  },
  methods: {
    ...mapActions([
      "updateCandidate",
      "fetchQualification",
      "deleteSplInterestWithoutToast",
      "fetchspecialInterest",
      "showToast",
      "fetchPQRLevels",
    ]),
    editProfessionalInfo() {
      this.EditModal.isShowPopup = true;
    },
    ProfessionalInfoModalCallBack(action, data, isSpecialityChanged) {
      this.EditModal.isShowPopup = false;
      if (action === true && data != null) {
        const { customer_uid } = this.profile;
        let appentAction = this.updateCandidate({ data, customer_uid });
        Promise.all([appentAction]).then((res) => {
          this.fetchPQRLevels();
          if (isSpecialityChanged?.length) {
            this.fetchQualification();
            if (
              this.getCandidateSpecialInterest?.length &&
              isSpecialityChanged.some((val) => val == "speciality_id")
            ) {
              this.splConfirmModal.isShowPopup = true;
            }
          }
        });
      }
    },
    splModalCallBack(action) {
      this.splConfirmModal.isShowPopup = false;
      if (action == "Yes") {
        let appendAction = [];
        this.getCandidateSpecialInterest.forEach((val) => {
          if (val.special_interest_id)
            appendAction = this.deleteSplInterestWithoutToast(
              val.candidate_speciality_id
            );
        });
        Promise.all([appendAction]).then((res) => {
          this.fetchspecialInterest();
          this.showToast({
            class: "bg-success text-white",
            message: "Special Interest reset successful",
          });
        });
        this.$parent.goToSplInterestSection();
      }
    },
    ShowMoreLess() {
      this.showMore = !this.showMore;
    },
    formatDate(date) {
      return date ? m(date).format('DD-MMM-YYYY') : date
    },
    formatMonthYear(date) {
      return date ? m(date).format('YYYY-MMM') : date
    },
  },
};
</script>
